import { toggleArticleCompanyUnit } from "../../../ArticleCRUD/ArticleCompanyUnits";
import { getBaseRowIndex } from "../../../ArticleCRUD/articleBaseRow";

export const toArticleDetail = row => ({
  articleSalesOptionsID: row.ArticleSalesOptionsID,
  companyUnitId: row.CompanyUnitId || 0,
  newBarcode: row.NewBarcode,
  articleUnitID: row.ArticleUnitID,
  typeOfSales: row.TypeOfSales,
  articleUnitQty: row.ArticleUnitQty,
  newSalesPrice: row.NewSalesPrice,
  isActive: row.IsActive ?? true,
  isBaseRow: row.isBaseRow,
});

export const toCompoundDetail = row => ({
  ArticleSalesOptionsID: row.articleSalesOptionsID || null,
  CompanyUnitId: row.companyUnitId || 0,
  NewBarcode: row.newBarcode,
  ArticleUnitID: row.articleUnitID,
  TypeOfSales: row.typeOfSales,
  ArticleUnitQty: row.articleUnitQty ?? 1,
  NewSalesPrice: row.newSalesPrice,
  IsActive: row.isActive ?? true,
  isBaseRow: row.isBaseRow,
});

export function toggleCompoundCompanyUnit(form, unitId, selected) {
  const updated = toggleArticleCompanyUnit({
    barcode: form.Barcode, unitId: form.UnitID, salePriceWithVat: form.SalesPrice,
    articleotherDetails: (form.ArticleOtherDetails || []).map(toArticleDetail),
  }, unitId, selected);
  return { ...form, ArticleOtherDetails: updated.articleotherDetails.map(toCompoundDetail) };
}

export function getCompoundBaseRowIndex(form) {
  return getBaseRowIndex({
    barcode: form.Barcode, unitId: form.UnitID,
    articleotherDetails: (form.ArticleOtherDetails || []).map(toArticleDetail),
  });
}

export function ensureCompoundBaseRows(form) {
  const rows = form.ArticleOtherDetails || [];
  const index = getCompoundBaseRowIndex(form);
  if (index >= 0) return rows.map((row, i) => i === index ? { ...row, isBaseRow: true } : row);
  return [...rows, {
    isBaseRow: true, ArticleSalesOptionsID: null, CompanyUnitId: 0,
    NewBarcode: form.Barcode, ArticleUnitID: form.UnitID, TypeOfSales: 1,
    ArticleUnitQty: 1, NewSalesPrice: form.SalesPrice ?? 0, IsActive: true,
  }];
}

export const isValidCompoundPrice = value =>
  (typeof value === "number" || typeof value === "string") &&
  Number.isFinite(Number(value)) && Number(value) >= 0;

// Hiding the options must not delete existing sale prices.
export function compoundDetailsForSave(form, showDetails, partial = {}) {
  const rows = form.ArticleOtherDetails || [];
  if (showDetails) return rows;
  const normalized = ensureCompoundBaseRows(form);
  return normalized.map(row => row.isBaseRow ? {
    ...row,
    NewBarcode: form.Barcode,
    ArticleUnitID: form.UnitID,
    NewSalesPrice: form.SalesPrice ?? 0,
    ...partial,
  } : row);
}

export function detailBarcodeConflict(rows, index) {
  const row = rows[index];
  const barcode = row.NewBarcode?.trim();
  return Boolean(barcode) && rows.some((other, otherIndex) =>
    index !== otherIndex && other.NewBarcode?.trim() === barcode &&
    Number(other.CompanyUnitId || 0) === Number(row.CompanyUnitId || 0));
}
